
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import theme from '@theme';
import Grid from 'styled-components-grid';

import { pb } from 'styled-components-spacing';

const { colors } = theme;

export const StyledMiniFlowWrapper = styled.div`
  max-width: 600px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 15px;
    max-width: 100%;
  }
  ${breakpoint('mobile', 'tablet')`
    padding: 0px;
  `}
`;

export const StyledFormGrid = styled.div`
  display: flex;
  flex-direction: column;
  /* gap: 20px; */

  @media (max-width: 768px) {
    /* gap: 15px; */
  }
`;

export const StyledContentTop = styled.div`
  display: flex;
  flex-direction: column;
  /* gap: 20px; */
  color: black !important;
  @media (max-width: 768px) {
    /* gap: 15px; */
  }
  ${breakpoint('mobile', 'tablet')`
    gap: 5px;
  `}
`;

export const StyledRadioGroup = styled.div`
  display: flex;
  /* gap: 15px; */
  margin-bottom: 10px;

  @media (max-width: 480px) {
    /* gap: 10px; */
    margin-bottom: 0px;
  }
  ${breakpoint('mobile', 'tablet')`
     margin-bottom: 0px;
     font-size: 12px;
  `}
`;

export const StyledName = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-bottom: 10px;

  @media (max-width: 480px) {
    gap: 5px;
    margin-bottom: 5px;
  }
`;

export const StyledFirstName = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledLastName = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledLabelNew = styled.label`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
  display: block;

  @media (max-width: 480px) {
    font-size: 13px;
    margin-bottom: 6px;
  }
`;

export const StyledInput = styled.input`
  width: 100% !important;
  padding: 0.5rem !important;
  padding-left: 1.5rem !important;
  border-radius: 4px !important;
  border: 1px solid rgba(36, 42, 56, 0.5) !important;
  background-color: #ffffff !important;
  font-size: 1rem !important;
  box-sizing: border-box !important;
  margin-top: 0.5rem !important;
  display: block !important;

  @media (max-width: 480px) {
    font-size: 12px !important;
    padding: 0.25rem !important;
  }
`;

export const StyledPhone = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;

  @media (max-width: 480px) {
    margin-bottom: 5px;
  }
`;

export const StyledItem = styled.div`
  margin-bottom: 10px;

  @media (max-width: 480px) {
    margin-bottom: 5px;
  }
`;

export const TermsAndConditionsWrapper = styled.div`
  display: flex;
  align-items: flex-start;

  @media (max-width: 480px) {
    align-items: center;
  }
`;

export const StyledLabelTextWrapper = styled.h6`
  color: #666;
  line-height: 1.4;
  font-size: 16px !important;

  @media (max-width: 480px) {
    font-size: 11px;
  }
  ${breakpoint('mobile', 'desktop')`
   font-size: 11px !important;
  `}
`;

export const StyledButtonSubmit = styled.button`
  background-color: #4a90e2;
  color: white;
  border: none;
  padding: 12px 20px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  width: 100%;

  &:hover {
    background-color: #3a7bc8;
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }

  @media (max-width: 480px) {
    padding: 10px 15px;
    font-size: 15px;
  }
  ${breakpoint('mobile', 'tablet')`
    padding-bottom: 10px;
    margin-bottom: 1rem;
  `}
`;

export const StyledItemSpacing = styled.div`
  margin-bottom: 10px;

  @media (max-width: 480px) {
    margin-bottom: 5px;
  }
`;

/* Enhanced Phone Input for mobile */
export const PhoneInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  
  input {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    
    &:focus {
      outline: none;
      border-color: #4a90e2;
    }

    @media (max-width: 480px) {
      padding: 10px;
      font-size: 16px;
    }
    ${breakpoint('mobile', 'tablet')`
      padding: 5px;
      font-size: 10px;
    `}
  }
`;

export const MobileOptimizedForm = styled.div`
  @media (max-width: 480px) {
    input, button {
      -webkit-appearance: none;
    }

    button, input[type="checkbox"] {
      min-height: 44px;
    }
  }
`;

export const StyledValidationMessage = styled.div`
  ${({ ValidationMessage }) => ValidationMessage
  && `
    padding-top:5px;
    font-size: 13px;
    color: #ffaebe;
    text-align: center;

  `}
  ${({ ValidationMessage }) => !ValidationMessage
  && `
    display:none;
  `}
`;

export const StyledEmailFormUnit = styled(Grid.Unit)`
${pb(3)}

.flag-dropdown{
      border: none !important;
      background-color: unset !important;
    }

    ${props =>
    (props.treatmentFormName
      ? `
      .react-tel-input{
      input{
        border: none !important;
      }
    }
    `
      : `
    .react-tel-input{
      input{
        border: 1px solid ${colors.translucentDarkBlue} !important;
      }
    }
    `)}

${breakpoint('mobile', 'desktop')`
    input{
      border-radius: 10px;
    }

    
    .react-tel-input{
      input{
        border-radius: 10px !important;
      }
    }
`}

${breakpoint('desktop')`
    ${props =>
    props.treatmentFormName
      && `
    input{
      border-radius: 4px;
    }

    .form-control{
      border-radius: 4px !important;
      
    }

    `}
`}
 .flag-dropdown{
      border: none;
    }

    ${props =>
    (props.treatmentFormName
      ? `
      .react-tel-input{
      input{
        border: none !important;
      }
    }
    `
      : `
    .react-tel-input{
      input{
        border: 1px solid ${colors.translucentDarkBlue};
      }
    }
    `)}
`;

export const StyledThankYou = styled.div`
  font-size: 20px;
  color: gray;
  line-height: 1.2;
  display: flex;
  flex-direction: column;
  svg{
    height: 20rem;
  }
    ${breakpoint('mobile', 'desktop')`
    text-align: center;
    font-size: 15px;
    svg{
      height: 10rem;
    }
  `}
`;
